import { DIDGenerator } from '@cp/shared/deviceId';

export const fingerprint: DIDGenerator = () =>
  import('get-browser-fingerprint')
    .then((module) => module.default)
    .then((getFP) => getFP())
    .then(String);
